/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      let amountText = this.querySelector('.free-shipping--text span');
      let total = parseInt(this.dataset.cartTotal, 10);
      // data-minimum-presentment is already in the cart's currency, so it must
      // NOT be multiplied by the rate -- the shipping rules use fixed local
      // amounts, not converted ones. data-minimum is the legacy shop-currency
      // value and still needs converting.
      let minimum = this.dataset.minimumPresentment
        ? parseInt(this.dataset.minimumPresentment, 10)
        : Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');

      if (total < minimum) {
        percentage = total / minimum;

        if (amountText) {
          let remaining = minimum - total;
          let format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amountText.innerHTML = formatMoney(remaining, format);
        }

        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'block';
          this.fullText.style.display = 'none';
        }
      } else {
        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'none';
          this.fullText.style.display = 'block';
        }
      }

      this.style.setProperty('--percentage', percentage);
    }
  }

  customElements.define('free-shipping', FreeShipping);
}

/**
 *  @class
 *  @function FreeShippingUpsell
 *
 *  One-tap add for the add-ons rendered under the free shipping bar. The
 *  markup is server rendered by 'free-shipping-upsell', so all this has to do
 *  is post the variant and fire 'cart:refresh' -- CartDrawer (app.js) and
 *  ThemeCart (cart.js) both listen for it and re-render their section, which
 *  redraws the bar, the gap and this list with the new cart state.
 */
if (!customElements.get('free-shipping-upsell')) {
  class FreeShippingUpsell extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        // Must stay narrow: the "Choose size" fallback is an <a> carrying the
        // same class for styling. Matching it here would preventDefault the
        // navigation and then post an undefined variant, so the link would do
        // nothing at all.
        const button = event.target.closest('button.free-shipping--upsell-add[data-variant-id]');
        if (!button) return;
        event.preventDefault();
        this.addToCart(button);
      });
    }

    addToCart(button) {
      if (this.busy) return;
      this.busy = true;
      button.classList.add('loading');
      button.disabled = true;

      const body = new FormData();
      body.append('id', button.dataset.variantId);
      body.append('quantity', 1);

      fetch(`${theme.routes.cart_add_url}`, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: body
      })
        .then((response) => response.json())
        .then((response) => {
          // The cart API answers errors with a status field and no line item.
          if (response.status) {
            this.reset(button);
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          // No reset on success: the refresh replaces this element outright.
        })
        .catch(() => {
          this.reset(button);
        });
    }

    reset(button) {
      button.classList.remove('loading');
      button.disabled = false;
      this.busy = false;
    }
  }

  customElements.define('free-shipping-upsell', FreeShippingUpsell);
}
